import ReactGA from "react-ga4";

// Main event method
const event = {
  Event: (category: string, action: string, label: string) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  },
};

// List of event methods that will be called
const eventLibrary = {
  // Click on social media link
  socialMedia: (social: string) => {
    GA.Event("Social Media Visited", social, "SOCIAL_MEDIA");
  },

  // Navigate to individual coin page
  coinSelected: (pathname: string, code: string) => {
    GA.Event(`Coin Selected ${pathname}`, code, "COIN_SELECTED");
  },

  // Select filter in markets page
  filterSelection: (filter: string) => {
    GA.Event("Filter Modal", filter, "FILTER_MODAL");
  },

  // Select table option in market page
  marketOption: (option: string) => {
    GA.Event("Market Option", option, "MARKET_OPTION_BUTTON");
  },

  // Select table page
  tableSelection: (option: string, page: string) => {
    GA.Event(`Table Selection <${option}>`, `Page ${page}`, "MARKET_PAGE_PAGINATION");
  },

  // track actions related to modals
  modal: (type: string, action: string) => {
    GA.Event(`Modal ${type}`, action, "MODAL");
  },

  // Refer And Earn
  referAndEarn: (page: string) => {
    GA.Event("Refer And Earn", page, "PAGE VISIT");
  },

  // Select currency conversion
  currencySelection: (currency: string) => {
    GA.Event("Currency Conversion", currency, "CURRENCY_CONVERSION");
  },

  // Select Advanced  Tools
  advancedTooling: (selected: string) => {
    GA.Event("Advanced Tools", selected, "ADVANCED_TOOLS");
  },
};

const GA = { ...event, ...eventLibrary };

export default GA;
